import { Box, Divider, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import { InviteCardProps } from "../types";
import { useSnapshot } from "valtio";
import { editorState } from "../../../../utils/editor";
import { getCoupleDisplayName } from "../../../../utils/couple.names";

const ThankYouNoteSample: React.FC<InviteCardProps> = ({
  w,
  h,
  px,
  border,
}) => {
  const { mainContent, groomFirstName, brideFirstName } =
    useSnapshot(editorState);
  return (
    <Flex
      flexDir={"column"}
      bg={"#fff"}
      py={"9.8px"}
      px={px ?? "24px"}
      border={border ?? "1px solid #00000033"}
      w={w ?? "full"}
      h={h ?? "full"}
      maxW={"398px"}
      maxH={"600px"}
      minH={"450px"}
      alignItems={"center"}
    >
      <Box
        bg={"#f9f9f9"}
        borderRadius={"18.59px"}
        fontFamily={"font4"}
        py={"7.5px"}
        px={"14.7px"}
        mb={"5px"}
      >
        <Text fontSize={"9.96px"} textTransform={"uppercase"}>
          {mainContent.hashtag}❤️
        </Text>
      </Box>
      <Divider bg={"#00000030"} orientation="horizontal" />
      <Text
        fontFamily={"font4"}
        fontSize={"12px"}
        fontWeight={600}
        textAlign={"center"}
        py={"7px"}
      >
        Thank You for Being Part of Our Special Day!
      </Text>
      <Image
        src={"/images/ring-yellow.png"}
        // src={mainContent.coupleImage}
        borderRadius={"16px"}
        h={"100px"}
        w={"100%"}
        objectFit={"cover"}
      />

      <Text
        fontFamily={"font4"}
        fontSize={"11px"}
        textAlign={"center"}
        py={"10px"}
      >
        Our hearts are so full, and we wanted to take a moment to thank you for
        being a part of our wedding day. We are so grateful to have you in our
        lives and to have created such beautiful memories together.
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={"11px"}
        textAlign={"center"}
        pb={"10px"}
      >
        As we embark on this new chapter, we carry with us the warmth and
        happiness that you brought to our special day.
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={"11px"}
        textAlign={"center"}
        pb={"10px"}
      >
        Thank you again for celebrating our love with us. We look forward to
        many more shared moments in the future.
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={"11px"}
        textAlign={"center"}
        pb={"5px"}
      >
        With love and appreciation,
      </Text>

      <Text
        fontFamily={"font4"}
        fontWeight={600}
        fontSize={"14px"}
        textAlign={"center"}
        w={"151.26px"}
        pb={"17px"}
      >
        {getCoupleDisplayName({
          brideFirstName,
          groomFirstName,
          coupleNameOrder: editorState.coupleNameOrder,
        })}
      </Text>
      <Flex
        bg={"#000"}
        borderRadius={"29.41px"}
        w={"195.2px"}
        py={"11px"}
        justifyContent={"center"}
        alignItems={"center"}
        fontSize={"0.765rem"}
        fontFamily={"font4"}
        textTransform={"uppercase"}
        letterSpacing={"1px"}
        fontWeight={600}
        color={"#fff"}
      >
        This is a sample
      </Flex>
    </Flex>
  );
};
export default ThankYouNoteSample;
